type StateFundingProgramCandidate = {
  abbreviation: string;
  fundingState: string | null;
  programRemoved?: boolean | null;
};

/**
 * Resolves the program a US state's families should be shown.
 *
 * A program's abbreviation is a slug rather than a state code, so most states
 * can only be matched through `fundingState` — Florida's program is `EMA`, for
 * example. An exact abbreviation match still wins, because several programs can
 * share a `fundingState` and the state's own program is the one to prefer.
 */
export function findFundingProgramForState<
  T extends StateFundingProgramCandidate,
>(programs: T[], stateAbbreviation: string | undefined | null): T | undefined {
  if (!stateAbbreviation) {
    return undefined;
  }

  const normalized = stateAbbreviation.toUpperCase();
  const available = programs.filter(program => !program.programRemoved);

  return (
    available.find(
      program => program.abbreviation.toUpperCase() === normalized,
    ) ??
    available.find(
      program => program.fundingState?.toUpperCase() === normalized,
    )
  );
}
